export const headerBottomBannerQuery = `query {
  homeCollection(where: {sys: {id: "7xRyKT9QS1D9BZd78KvV3M"}}) {
    items {
      headerBannerApp {
        ... on ImageBannerWeb {
          referenceType
          reference
          saleChannels
          imageMobile {
            url
          }
          imageDesktop {
            url
          }
        }
      }
    }
  }
}
`
